import { render, staticRenderFns } from "./SchoolEventUploadSlidebar.vue?vue&type=template&id=c4459d22"
import script from "./SchoolEventUploadSlidebar.vue?vue&type=script&lang=js"
export * from "./SchoolEventUploadSlidebar.vue?vue&type=script&lang=js"
import style0 from "./SchoolEventUploadSlidebar.vue?vue&type=style&index=0&id=c4459d22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports